<template>
  <div>
    <!-- create empty div under the absolutely positioned menu so the other content will align properly -->
    <div class="filler"></div>

    <!-- menu bar-->
    <div class="menu-bar w-100 fixed-top d-flex" :class="menuOpen ? 'position-fixed' : 'position-absolute'">
      <div class="wrapper pt-5 px-4">
        <div class="row justify-content-between" >
          <div class="col-4 d-inline-flex">
            <div @mouseover="onLogoHover(true)" @mouseleave="onLogoHover(false)">
              <router-link to="/" >
                <img src="~@/assets/img/logo.svg" alt="amio logo" class="amio-logo">
              </router-link>
            </div>
            <!--animation disabled-->
            <!--<div class="white-box amio-logo d-none d-md-block" :class="boxClass"></div>-->
          </div>
          <div class="col-7 d-flex justify-content-end">
            <div class="d-flex pointer" :class="menuOpen ? 'text-white menu-hover' : ''" @click="toggleMenu">
              <span class="d-none d-md-inline ml-5 my-auto bold">
                {{menuOpen ? 'Close' : 'Menu'}}
              </span>
              <div id="menu_burger" class="z-2000 d-inline my-auto ml-3" :class="menuOpen ? 'open' : ''" >
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- menu content -->
    <div v-if="menuOpen" class="font-larger menu-content menu-font h-100 position-fixed fixed-top d-flex flex-column">
      <div class="filler"></div>

      <router-link to="/product" class="text-decoration-none text-reset mt-3 mt-md-4">
        <div class="menu-item menu-hover py-4 pointer">
          <span>Product</span>
        </div>
      </router-link>
      <div class="menu-item py-3">
        <b-button v-b-toggle.collapse-developers variant="link" class="menu-hover d-inline-flex w-100 justify-content-between text-decoration-none text-reset px-0">
          <span class="font-larger menu-font">Developers</span>
          <span class="d-md-none collapse-icon mr-4"><img src="~@/assets/img/arrow_down.svg" alt=""></span>
          <span class="d-none d-md-inline collapse-icon mr-4"><img src="~@/assets/img/arrow_down_white.svg" alt=""></span>
        </b-button>
        <b-collapse id="collapse-developers" class="mt-2">
          <div>
            <div class="ml-4"><a href="https://docs.amio.io/" class="menu-hover text-decoration-none text-reset font-smaller">Documentation</a></div>
            <div class="ml-4 mt-2"><a href="https://docs.amio.io/v1.0/reference" class="menu-hover text-decoration-none text-reset font-smaller">API Reference</a></div>
            <div class="ml-4 mt-2"><a href="https://github.com/amio-io/amio" class="menu-hover text-decoration-none text-reset font-smaller">SDKs</a></div>
            <div class="ml-4 mt-2"><a href="https://stats.uptimerobot.com/ANyMkCJ54/" class="menu-hover text-decoration-none text-reset font-smaller">Status</a></div>
          </div>
        </b-collapse>
      </div>
      <a href="https://blog.amio.io" class="text-decoration-none text-reset">
        <div class="menu-item menu-hover py-4 pointer">
          <span>Blog</span>
        </div>
      </a>

      <div class="d-flex flex-column mt-auto mb-5">
        <div class="d-flex justify-content-between d-md-inline my-0 mx-4 mx-md-0">
          <div class="social-link font-smaller mt-4">
            <a href="https://automate.amio.io/login" class="text-reset text-decoration-none">
              <div>
                <img class="d-md-none" src="~@/assets/img/login.svg" alt="login" height="24px">
                <img class="d-none d-md-inline" src="~@/assets/img/login_white.svg" alt="login" height="24px">
                <span class="menu-hover ml-3 bold">Login</span>
              </div>
            </a>
          </div>
          <div class="social-link font-smaller mt-4">
            <a href="https://www.linkedin.com/company/amio.io" target="_blank" class="text-reset text-decoration-none">
              <div>
                <img class="d-md-none" src="~@/assets/img/social/linkedin.svg" alt="linkedin">
                <img class="d-none d-md-inline" src="~@/assets/img/social/linkedin_white.svg" alt="linkedin">
                <span class="menu-hover ml-3 bold">LinkedIn</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import analyticsMixin from '@/mixins/analytics.mixin'
  import 'vue-awesome/icons/angle-down'

  export default {
    mixins: [analyticsMixin],

    data() {
      return {
        boxClass: '',
        menuOpen: false
      }
    },

    methods: {
      onLogoHover(isHovered) {
        if (isHovered) this.boxClass = 'slide-in'
        else this.boxClass = 'slide-out'
      },

      enableScroll() {
        const el = document.body
        el.classList.remove('h-100', 'overflow-hidden')
      },

      disableScroll() {
        const el = document.body
        el.classList.add('h-100', 'overflow-hidden')
      },

      toggleMenu() {
        this.menuOpen = !this.menuOpen

        if (this.menuOpen) {
          this.disableScroll()
        } else {
          this.enableScroll()
        }
      }
    }
  }
</script>

<style scoped>

  .wrapper {
    width: 100%;
  }

  .menu-content {
    width: 100%;
    background-color: white;
  }

  .menu-font {
    font-weight: 200 !important;
  }

  .menu-item {
    border-bottom: 1px solid #E4E9F5;
    margin-left: 1.5rem;
  }

  .social-link {
    color: #6E40FF;
  }

  /* md breakpoint */
  @media (min-width: 880px) {
    .amio-logo {
      height: 48px;
    }

    .menu-content {
      width: 600px;
      left: auto;
      background-color: #6e40ff;
      color: white !important;
    }

    .menu-item {
      border: 0 transparent !important;
      width: 50%;
      margin-left: 125px;
    }

    .menu-hover:hover {
      color: rgba(255, 255, 255, 0.7) !important;
    }

    .menu-font {
      font-weight: 400 !important;
    }

    .wrapper {
      width: 100%;
      margin-left: 10%;
      margin-right: 10%;
    }

    .social-link {
      color: #fff;
      margin-left: 125px !important;
      margin-right: 0 !important;
    }

    #menu_burger.open span {
      background: #fff !important;
    }
  }

  .collapsed > .collapse-icon {
    transform: scale(1, 1);
    transition: .5s ease-in-out;
  }

  .collapse-icon {
    transform: scale(1, -1);
    transition: .5s ease-in-out;
  }

  .pointer {
    cursor: pointer;
  }

  .font-larger {
    font-size: larger;
  }

  .font-smaller {
    font-size: smaller;
  }

  .filler {
    height: 100px;
  }

  .menu-bar {
    z-index: 2000;
  }

  .slide-in {
    animation: slide-in 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  }

  .slide-out {
    animation: slide-out 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation-delay: 0.5s;
  }

  .white-box {
    width: 100px;
    background-color: white;
    margin-left: -80px;
  }

  .amio-logo {
    height: 36px;
  }

  .no-scroll {
    height: 100%;
    overflow-y: hidden;
  }

  #menu_burger {
    width: 30px;
    height: 22px;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .5s ease-in-out;
    -moz-transition: .5s ease-in-out;
    -o-transition: .5s ease-in-out;
    transition: .5s ease-in-out;
    cursor: pointer;
  }

  #menu_burger span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: #000;
    border-radius: 10px;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .25s ease-in-out;
    -moz-transition: .25s ease-in-out;
    -o-transition: .25s ease-in-out;
    transition: .25s ease-in-out;
  }

  #menu_burger.open {
    transform: scale(0.8, 0.8);
    transform-origin: bottom center;
  }

  #menu_burger.open span {
    background: #000;
  }

  #menu_burger span:nth-child(1) {
    top: 0px;
  }

  #menu_burger span:nth-child(2), #menu_burger span:nth-child(3) {
    top: 9px;
  }

  #menu_burger span:nth-child(4) {
    top: 18px;
  }

  #menu_burger.open span:nth-child(1) {
    top: 9px;
    width: 0%;
    left: 50%;
  }

  #menu_burger.open span:nth-child(2) {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  #menu_burger.open span:nth-child(3) {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  #menu_burger.open span:nth-child(4) {
    top: 9px;
    width: 0%;
    left: 50%;
  }

  @media (min-width: 1500px) {
    .feature {
      width: 80%;
    }
  }

  @keyframes slide-in {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(80px);
    }
  }

  @keyframes slide-out{
    0% {
      transform: translateX(80px);
    }

    100% {
      transform: translateX(0);
    }
  }

</style>
